import { render } from "./dashboard.vue?vue&type=template&id=029406e7"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
script.render = render

export default script